export { default } from "./CardText"
